import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import UpArrow from "../../../images/arrow-up-orange.svg"
import { Image } from "semantic-ui-react"

const EXPANDED = "expanded"

const FuelcardFAQ = () => {
  const { t } = useTranslation("fuelcardRequest")

  const [faqs, setFaqs] = useState([
    {
      question: t("faq1"),
      answer: t("faq1Answer"),
      [EXPANDED]: false
    },
    {
      question: t("faq2"),
      answer: t("faq2Answer"),
      [EXPANDED]: false
    },
    {
      question: t("faq3"),
      answer: t("faq3Answer"),
      [EXPANDED]: false
    },
    {
      question: t("faq4"),
      answer: t("faq4Answer"),
      [EXPANDED]: false
    }
  ])

  const handleCollapseAndExpand = (index) => {
    setFaqs((prev) => {
      const newState = [...prev]
      newState[index] = {
        ...newState[index],
        [EXPANDED]: !newState[index][EXPANDED]
      }
      return newState
    })
  }

  return (
    <div className="fuelcard-faq">
      <p className="faq-header">{t("FAQ")}</p>
      <div className="faq-box">
        {faqs.map((faq, index) => (
          <div key={faq.question} className="faq-list">
            <div className="faq-list-header">
              <p>{faq.question}</p>
              <Image
                className={`faq-arrow ${faq.expanded ? "" : "faq-arrow-rotate"}`}
                src={UpArrow}
                onClick={() => handleCollapseAndExpand(index)}
              />
            </div>
            {faq[EXPANDED] && <p className="faq-details">{faq.answer}</p>}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FuelcardFAQ
